export default __webpack_public_path__ + "static/media/Women_fr.afeec927.svg";